import React from "react";

export default function CalculationDetails({ result }) {
  if (!result.metrics)
    return (
      <p className="source">
        Formula details were not recorded for this older calculation.
      </p>
    );
  return (
    <details className="calculation-details">
      <summary>How these figures were calculated</summary>
      <p className="source">
        Based on your scenario inputs.{" "}
        {result.rounding ||
          "Money is calculated using decimal arithmetic; duty follows the versioned QRO rate table."}
      </p>
      {result.metrics.map((metric) => (
        <div key={metric.id} className="formula-row">
          <strong>{metric.label}</strong>
          <p>{metric.derivation}</p>
          <small>
            {metric.id} · {metric.calc_version}
            {metric.rules_version ? ` · ${metric.rules_version}` : ""}
          </small>
        </div>
      ))}
    </details>
  );
}
